// src/components/home/proofStrip.js
//
// Pure helpers for the proof strip and the free-lesson CTA (home-4b-proof).
//
// THE RULE THIS FILE EXISTS TO ENFORCE: the strip renders ONLY material that is
// already real and already approved -- the credential tiles, and testimonials that
// Danielle has both written AND switched on. There is deliberately no code path here
// that can produce a quote, a rating, a star count, a "students taught" number or an
// outcome statistic, because none of those exist as data. If nothing real is
// available, the strip is the credentials alone; it is never padded.
//
// Being a tested function rather than an inline `&&` is the point: a future restyle
// cannot loosen the gate by accident.

// At most three testimonials in the strip -- the section is proof, not a wall.
export const MAX_PROOF_TESTIMONIALS = 3;

// Real, approved testimonials only:
//   - testimonialsEnabled must be true (Danielle's own switch), AND
//   - the entry must carry a non-blank quote (a seeded blank row is not a testimonial).
// Anything else yields [] and the caller shows the credentials alone.
export function proofTestimonials(siteText, max = MAX_PROOF_TESTIMONIALS) {
    const st = siteText || {};
    if (!st.testimonialsEnabled) return [];
    const n = Math.max(0, Math.floor(Number(max) || 0));
    return (Array.isArray(st.testimonials) ? st.testimonials : [])
        .filter((t) => t && typeof t.quote === 'string' && t.quote.trim())
        .slice(0, n);
}

// The free-lesson CTA: where it goes, what it says, and whether it is honest to
// repeat it at all.
//
//   signed in                     -> their library; "Try a free lesson" is the wrong
//                                    words for someone who already has the packs
//   a pack with free items exists -> that pack's PUBLIC free preview
//   otherwise                     -> sign-up, and the words CHANGE
//
// That last branch is the point. "Try a free lesson" is a claim, and if no published
// pack currently exposes a free item the claim is false -- so the label becomes the
// account CTA and `repeat` goes false, which drops the second copy of it near the
// foot of the page. The same rule that keeps invented testimonials off the page keeps
// an invented free lesson off it.
export function freeLessonOffer(packs, signedIn) {
    if (signedIn) return { href: '/dashboard', label: 'Go to your library', repeat: true, free: false };
    const list = Array.isArray(packs) ? packs : [];
    const withFree = list.find((p) => p && p.status === 'available' && Number(p.freeItems) > 0);
    if (withFree) return { href: '/preview/' + withFree.id, label: 'Try a free lesson', repeat: true, free: true };
    return { href: '/login?mode=signup', label: 'Create your account', repeat: false, free: false };
}
